import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=21ff4aa6&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=21ff4aa6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff4aa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ff4aa6')) {
      api.createRecord('21ff4aa6', component.options)
    } else {
      api.reload('21ff4aa6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=21ff4aa6&scoped=true", function () {
      api.rerender('21ff4aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/check_in_details_report/components/detail.vue"
export default component.exports